/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ACLINFO } from '../model/aCLINFO';
import { USERINFO } from '../model/uSERINFO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UsersService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * List all users
     * @param offset An offset for a list (required for pagination)
     * @param limit A maximum number of entries returned by the request
     * @param searchString String to search for users in fields userId, firstName, lastName, email and phone
     * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - userid,  - firstname,  - lastname,  - email,  - phone
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<USERINFO>>;
    public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<USERINFO>>>;
    public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<USERINFO>>>;
    public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (searchString !== undefined) {
            queryParameters = queryParameters.set('search_string', <any>searchString);
        }
        if (sortString !== undefined) {
            queryParameters = queryParameters.set('sort_string', <any>sortString);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<USERINFO>>(`${this.basePath}/users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Number of users getting operation. This is the operation to get a number of card groups managed by the authenticated account
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersHead(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public usersHead(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public usersHead(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public usersHead(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.head<any>(`${this.basePath}/users`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Create a new user
     * @param userInfo User information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersPut(userInfo: USERINFO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public usersPut(userInfo: USERINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public usersPut(userInfo: USERINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public usersPut(userInfo: USERINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userInfo === null || userInfo === undefined) {
            throw new Error('Required parameter userInfo was null or undefined when calling usersPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/users`,
            userInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a user
     * @param userId User ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdDelete(userId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public usersUserIdDelete(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public usersUserIdDelete(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public usersUserIdDelete(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get user by ID
     * @param userId User ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdGet(userId: string, observe?: 'body', reportProgress?: boolean): Observable<USERINFO>;
    public usersUserIdGet(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<USERINFO>>;
    public usersUserIdGet(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<USERINFO>>;
    public usersUserIdGet(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<USERINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Remove the permissions for user
     * @param userId User ID
     * @param objectType Type of object
     * @param objectId ID of object
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsDelete.');
        }
        if (objectType === null || objectType === undefined) {
            throw new Error('Required parameter objectType was null or undefined when calling usersUserIdPermissionsDelete.');
        }
        if (objectId === null || objectId === undefined) {
            throw new Error('Required parameter objectId was null or undefined when calling usersUserIdPermissionsDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (objectType !== undefined) {
            queryParameters = queryParameters.set('object_type', <any>objectType);
        }
        if (objectId !== undefined) {
            queryParameters = queryParameters.set('object_id', <any>objectId);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get the permissions for user
     * @param userId User ID
     * @param objectType Filter for object type
     * @param objectId Filter for object ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ACLINFO>>;
    public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ACLINFO>>>;
    public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ACLINFO>>>;
    public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (objectType !== undefined) {
            queryParameters = queryParameters.set('object_type', <any>objectType);
        }
        if (objectId !== undefined) {
            queryParameters = queryParameters.set('object_id', <any>objectId);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<ACLINFO>>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update the permissions for user
     * @param userId User ID
     * @param aclInfo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe?: 'body', reportProgress?: boolean): Observable<ACLINFO>;
    public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ACLINFO>>;
    public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ACLINFO>>;
    public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsPost.');
        }
        if (aclInfo === null || aclInfo === undefined) {
            throw new Error('Required parameter aclInfo was null or undefined when calling usersUserIdPermissionsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ACLINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
            aclInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Create new permission for user
     * @param userId User ID
     * @param aclInfo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe?: 'body', reportProgress?: boolean): Observable<ACLINFO>;
    public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ACLINFO>>;
    public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ACLINFO>>;
    public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsPut.');
        }
        if (aclInfo === null || aclInfo === undefined) {
            throw new Error('Required parameter aclInfo was null or undefined when calling usersUserIdPermissionsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ACLINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
            aclInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update the user info
     * @param userId User ID
     * @param userInfo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdPost(userId: string, userInfo: USERINFO, observe?: 'body', reportProgress?: boolean): Observable<USERINFO>;
    public usersUserIdPost(userId: string, userInfo: USERINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<USERINFO>>;
    public usersUserIdPost(userId: string, userInfo: USERINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<USERINFO>>;
    public usersUserIdPost(userId: string, userInfo: USERINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdPost.');
        }
        if (userInfo === null || userInfo === undefined) {
            throw new Error('Required parameter userInfo was null or undefined when calling usersUserIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<USERINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
            userInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/users.service.ts